export const phrasePatterns = [
  "anyone else struggle with",
  "how do i",
  "what's the best way to",
  "template for",
  "tool for",
  "i'm stuck",
  "i can't figure out",
  "i need help with",
  "i’m overwhelmed by",
  "is there a way to",
//  "how the hell do you",
//  "tips for",
//  "checklist for",
//  "planning help for",
//  "workflow for",
//  "system for",
//  "recommendations for",
//  "does anyone use",
//  "why is it so hard to",
//  "how do you guys handle",
//  "is there a guide for",
//  "struggling with",
//  "looking for a way to"
];
